import classNames from 'classnames';

import { CheckboxIcon, CheckboxFilledIcon, RadioIcon, RadioFilledIcon } from '../../../../icons';

import PopoverItem from '../Item';

import styles from './_index.module.scss';

export interface PopoverInputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  type?: 'checkbox' | 'radio';
}

const PopoverInput = ({
  checked,
  children,
  className,
  id,
  type = 'checkbox',
  ...props
}: PopoverInputProps) => {
  const icon =
    type === 'checkbox' ? (
      checked ? (
        <CheckboxFilledIcon />
      ) : (
        <CheckboxIcon />
      )
    ) : checked ? (
      <RadioFilledIcon />
    ) : (
      <RadioIcon />
    );

  return (
    <PopoverItem
      as="label"
      className={classNames(styles[`popover-${type}`], className, {
        [styles['is-active']]: checked,
      })}
      htmlFor={id}
      icon={icon}
    >
      <>
        <input
          checked={checked}
          className={styles['popover-input']}
          id={id}
          type={type}
          {...props}
        />
        {children}
      </>
    </PopoverItem>
  );
};

export const PopoverCheckbox = (props: Omit<PopoverInputProps, 'type'>) => {
  return <PopoverInput type="checkbox" {...props} />;
};
export const PopoverRadio = (props: Omit<PopoverInputProps, 'type'>) => {
  return <PopoverInput type="radio" {...props} />;
};

export default PopoverInput;
